import React from "react";
import MfeReactElement from "./components/MfeReactElement";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import Loader from "./components/loader/Loader";
import { Tolgee, TolgeeProvider, InContextTools, TolgeeInstance } from "@tolgee/react";
import { FormatIcu } from "@tolgee/format-icu";
import { LocalStorageService } from "./services/localStorageService";
import RoutesComponent from "./routes";
import HistoryBrowserRouter, { staticHistory } from "./router/HistoryBrowserRouter";
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import "./styles/_modals.scss";

const getDefaultLang = () => {
  const currentLanguage = LocalStorageService.instance.getLanguage();
  if (currentLanguage) {
    return currentLanguage;
  }

  return "en-US";
};

const tolgee: TolgeeInstance = Tolgee()
  .use(FormatIcu())
  .use(InContextTools())
  .init({
    defaultLanguage: getDefaultLang(),
    language: getDefaultLang(),
    apiUrl: process.env.TOLGEE_API_URL,
    apiKey: process.env.TOLGEE_API_KEY,
    projectId: 4,
    defaultNs: "",
    availableLanguages: ["en-US", "de", "es", "it", "ru-RU", "uk-UA"],
    fallbackLanguage: getDefaultLang(),
  });

export const translate = (key: string, params: any = {}): string => {
  if (tolgee.isRunning()) {
    return tolgee.t({ key: key, params: params });
  } else {
    return key;
  }
};

const App = () => {
  return (
    <TolgeeProvider tolgee={tolgee} fallback={<Loader type="fullscreen" />}>
      <ConfigProvider locale={enUS}>
        <Provider store={store}>
          <HistoryBrowserRouter basename="/pages" history={staticHistory}>
            <RoutesComponent />
          </HistoryBrowserRouter>
        </Provider>
      </ConfigProvider>
    </TolgeeProvider>
  );
};

if (!customElements.get("react-element-pages")) {
  customElements.define("react-element-pages", MfeReactElement);
}

if (module.hot) {
  module.hot.accept();
}

export default App;
